import {
  globalGetService,
  globalPostService,
  globalPutService,
} from '@/utils/globalApiServices';
import { Pagination } from '@/utils/types';
import {
  CampaignDetail,
  CampaignListItem,
  CampaignSharingChain,
  CampaignStatusParams,
  CampaignVerification,
  ComplaintParams,
  SenderId,
} from './types';

export const getCampaigns = async (queries: Record<string, any> = {}) => {
  const response = await globalGetService('mno/campaigns', {
    ...queries,
  });
  return response?.ok
    ? (response.data as Pagination<CampaignListItem>)
    : undefined;
};

export const getCampaign = async (uid: string) => {
  const response = await globalGetService(`mno/campaigns/${uid}`);
  return response?.ok ? (response.data as CampaignDetail) : undefined;
};

export const getSharingChain = async (
  uid: string,
  params?: { provisional?: boolean }
) => {
  const response = await globalGetService(
    `mno/campaigns/${uid}/sharingChain`,
    params
  );
  return response?.ok ? (response.data as CampaignSharingChain) : undefined;
};

export const getVerification = async (
  uid: string,
  configs?: Record<string, unknown>
) => {
  const response = await globalGetService(
    `mno/campaigns/${uid}/verification`,
    undefined,
    configs
  );
  const parseJson = (val: string | null) => {
    try {
      if (typeof val === 'string') return JSON.parse(val);
      return val;
    } catch {
      return val;
    }
  };
  return response?.ok
    ? ({
        ...response.data,
        fullReport: parseJson(response.data.fullReport),
        reasons: parseJson(response.data.reasons),
      } as CampaignVerification)
    : undefined;
};

export const updateCampaignStatus = async (
  campaignUid: string,
  params: CampaignStatusParams
) => {
  const response = await globalPutService(
    `mno/campaigns/${campaignUid}/status`,
    params
  );
  return !!response?.ok;
};

export const fileComplaint = async (
  campaignUid: string,
  params: ComplaintParams
) => {
  const response = await globalPostService(
    `mno/campaigns/${campaignUid}/complaint`,
    params
  );
  return !!response?.ok;
};
